// extracted by mini-css-extract-plugin
module.exports = {"lotteryRegistrationWrapper":"_2dBFugDwELOjcBSAP3plkV","lotteryRegistrationContainer":"_1s1JL7LQCahXWNJVSKw3tr","submitButton":"_1A0d4ipKW5N1QgtkqkhEVA"};